module.exports = __webpack_public_path__ + "static/media/fashion-women-1-min.5775f3be.jpg";